import { render, staticRenderFns } from "./BindLoyalty.vue?vue&type=template&id=a56dc554&scoped=true"
import script from "./BindLoyalty.vue?vue&type=script&lang=js"
export * from "./BindLoyalty.vue?vue&type=script&lang=js"
import style0 from "./BindLoyalty.vue?vue&type=style&index=0&id=a56dc554&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56dc554",
  null
  
)

export default component.exports